import { useInfiniteQuery } from "@tanstack/react-query";

import { filtersToQuery } from "../lib/listingFilters";
import { getStorefrontProducts } from "../services/frontend/storefront-apis";

const fetchStorefrontProducts = async ({ queryKey, pageParam = 1 }) => {
  const [, collectionName, filters] = queryKey;

  const data = await getStorefrontProducts({
    page: pageParam,
    limit: 20,
    collection: collectionName || "all",
    filters,
  });

  return {
    products: data.products || [],
    priceRange: data.priceRange || null,
    nextPage: pageParam + 1,
    previousPage: pageParam > 1 ? pageParam - 1 : null,
    hasNextPage: Boolean(data.hasNextPage),
  };
};

/** `filters`: lib/listingFilters shape; part of the query key, so each filter set caches apart. */
const useStorefrontProducts = (collectionName, filters) => {
  const enabled = Boolean(collectionName) && collectionName !== "__none__";

  return useInfiniteQuery({
    queryKey: ["storefrontProducts", collectionName, filtersToQuery(filters)],
    queryFn: fetchStorefrontProducts,
    getNextPageParam: (lastPage) => (lastPage.hasNextPage ? lastPage.nextPage : undefined),
    cacheTime: 30 * 1000,
    staleTime: 30 * 1000,
    // Keep the old listing only while switching between real queries; while the route is still
    // resolving (no key yet) show the loading state, not the previous collection's products.
    keepPreviousData: enabled,
    enabled,
  });
};

export default useStorefrontProducts;
